import {type EndGameData} from '@colonist/game-base-types'
import {type TranslationObject} from '@colonist/i18n'
import {type NonFunctionProperties} from '@colonist/types'
import {BaseRankedUserState, RankedUserStateType} from './BaseRankedUserState.ts'

export class RankedLockedState extends BaseRankedUserState {
    readonly type = RankedUserStateType.RankedLocked

    readonly numberOfGamesPlayed: number
    readonly requiredNumberOfGames: number
    readonly defaultEndGameData: EndGameData

    constructor(numberOfGamesPlayed: number, requiredNumberOfGames: number) {
        super()
        this.numberOfGamesPlayed = numberOfGamesPlayed
        this.requiredNumberOfGames = requiredNumberOfGames
        this.defaultEndGameData = {
            amount: '-',
            highest: false,
        }
    }

    finishedPlacementGames(): boolean {
        return this.numberOfGamesPlayed >= this.requiredNumberOfGames
    }

    getEndGameScreenText() {
        const remainingGames = this.requiredNumberOfGames - this.numberOfGamesPlayed

        const title: TranslationObject = {
            key: 'strings:game.endGame.rankedUpdate.lockedTitle',
            options: {
                gamesPlayedCount: this.numberOfGamesPlayed,
                requiredGamesCount: this.requiredNumberOfGames,
            },
        }

        const description: TranslationObject = {
            key: 'strings:game.endGame.rankedUpdate.lockedDescription',
            options: {
                count: remainingGames,
            },
        }

        return {
            title: title,
            description: description,
        }
    }

    getEndGameData(): EndGameData {
        return this.defaultEndGameData
    }

    getFindGamePopupStatusText(): TranslationObject {
        return {
            key: 'strings:colonistCommon.rankedState.gamesPlayed',
            options: {
                gamesPlayedCount: this.numberOfGamesPlayed,
                count: this.requiredNumberOfGames,
            },
        }
    }

    static deserialize(data: NonFunctionProperties<RankedLockedState>): BaseRankedUserState {
        const newRankedState = new RankedLockedState(data.numberOfGamesPlayed, data.requiredNumberOfGames)
        return newRankedState
    }
}
